// extracted by mini-css-extract-plugin
export default {"deliveryDetails":"DeliveryDetails_deliveryDetails__0GbQR"};